document.addEventListener('DOMContentLoaded', function () {
    const contentEl = document.querySelector('.seo-block__wrapper');
    const btnEl = document.querySelector('.seo-block__btn');

    if (!contentEl || !btnEl) return;

    const textLength = contentEl.textContent.trim().length;

    if (textLength > 550) {
        contentEl.classList.add('seo-block__wrapper--hidden');
    } else {
        btnEl.style.display = 'none';
    }

    btnEl.addEventListener('click', function () {
        btnEl.style.display = 'none';
        contentEl.classList.remove('seo-block__wrapper--hidden');
    })
});